<template>
  <div v-if="problem.attachments && problem.attachments.length">
    附件：<a v-for="(a) in problem.attachments" class="attachment" @click="$emit('download-attachment', a)">
    <v-color-icon name="link" size="14"></v-color-icon>
    {{ a.name }}</a>
  </div>
</template>
<script>
export default {
  props: ['problem']
}
</script>
<style lang="stylus" scoped>
.attachment {
  color $link
  cursor pointer
  margin-right 5px

  &:hover {
    text-decoration underline
  }
}
</style>
